import { cva } from 'class-variance-authority'

export const cardVariants = cva('rounded-[10px] text-card-foreground', {
  variants: {
    variant: {
      default:
        'bg-card dark:bg-card/60 dark:backdrop-blur-xl border border-border dark:border-white/[0.06] shadow-[0_2px_4px_-1px_rgba(0,0,0,0.06),0_1px_2px_-1px_rgba(0,0,0,0.04)] dark:shadow-[0_4px_24px_rgba(0,0,0,0.3)]',
      feature:
        'bg-feature-texture text-white border-0 shadow-lg dark:shadow-[0_8px_32px_rgba(0,0,0,0.3)]',
      aurora: 'bg-aurora text-white border-0',
      outline: 'bg-transparent border-2 border-dashed border-primary/30',
      ghost: 'bg-transparent border-0',
      clickable:
        'bg-card dark:bg-card/60 dark:backdrop-blur-xl border border-border dark:border-white/[0.06] cursor-pointer hover-lift shadow-[0_2px_4px_-1px_rgba(0,0,0,0.06),0_1px_2px_-1px_rgba(0,0,0,0.04)] dark:shadow-[0_4px_24px_rgba(0,0,0,0.3)]',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})
